import { Component } from '@angular/core';

@Component({
  selector: 'public-landing-page-layout',
  templateUrl: './public-landing-page-layout.component.html',
})
export class PublicLandingPageLayoutComponent {}
